import React from "react";
import "./ToolSkills.css";
import { FaAdn, FaGithub, FaTrello } from "react-icons/fa";
import { DiVisualstudio } from "react-icons/di";
import { SiXampp, SiLaragon, SiPycharm, SiNotion } from "react-icons/si";
const ToolSkills = () => {
  return (
    <div className="container">
      <div className="parent">
        <div className="item3">
          <div>
            <DiVisualstudio />
          </div>
        </div>
        <div className="item3">
          <div>
            <SiXampp />
          </div>
        </div>
        <div className="item3">
          <div>
            <SiLaragon />
          </div>
        </div>
        <div className="item3">
          <div>
            <SiNotion />
          </div>
        </div>
        <div className="item3">
          <div>
            <FaGithub />
          </div>
        </div>
        <div className="item3">
          <div>
            <FaTrello />
          </div>
        </div>
        <div className="item3">
          <div>
            <SiPycharm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolSkills;
